module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-down--i.03ea54f0.svg";